import { Stack, Typography, Button, Box } from '@mui/material';
import SiloRealLogo from '@old/assets/logos/siloreal-logo-black.webp';
import { useNavigate } from 'react-router';
import { ModalIOF } from '@old/ui/modal/modal';
import { separatorReports } from '@old/styles/generic-styles';
import blueSojaIcon from '@old/assets/svg/icons-species-blue/soja-icon-blue.svg';
import blueMaizIcon from '@old/assets/svg/icons-species-blue/maiz-icon-blue.svg';
import blueTrigoIcon from '@old/assets/svg/icons-species-blue/trigo-icon-blue.svg';
import { configButtonStylesContained } from '@old/styles/generic-styles';
import { PATH } from '@old/data/core/paths';
import { useGlobalStore } from '@old/global-store/use-store';
import { useService } from '@old/hooks/use-service';
import rusLogo from '@old/assets/svg/rus-icon.svg';
import { updateUserDataService } from '@old/services/domain/user/base/user-edition';

type RusModalProps = {
  open: boolean;
  setOpen: (value: boolean) => void;
};

export default function RusIntegrationModal(props: RusModalProps) {
  const { userID, setIshowOneModal } = useGlobalStore();
  const { trigger } = useService(updateUserDataService);
  const navigate = useNavigate();
  const { open, setOpen } = props;
  return (
    <ModalIOF open={open} ModalIsOpen={setOpen} width="48%">
      <ModalIOF.HeaderCenter>
        <ModalIOF.Title>
          <Stack direction="row" spacing={1} justifyContent={'space-around'} alignItems={'center'}>
            <Box sx={separatorReports}>
              <img
                src={SiloRealLogo}
                alt="SiloReal Logo"
                style={{ width: '140px', padding: 10, marginRight: '10px' }}
              />
            </Box>
            <Box>
              <img src={rusLogo} alt="La Segunda Logo" style={{ width: '140px', padding: 10 }} />
            </Box>
          </Stack>
        </ModalIOF.Title>
      </ModalIOF.HeaderCenter>
      <ModalIOF.Body>
        <Stack direction="column" spacing={2} sx={{ textAlign: 'center' }}>
          <Typography variant="h5" sx={{ fontWeight: 500 }}>
            Nueva integración con RUS
          </Typography>
          <Typography variant="body1" sx={{ fontWeight: 500 }}>
            Ahora desde SiloReal vas a ver las cotizaciones de coberturas de seguros con RUS de tus siloreales
            y avanzar con la contratación.
          </Typography>
          <Stack direction={'row'} justifyContent={'center'}>
            <Box>
              <img src={blueSojaIcon} alt="Soja" style={{ width: '50px', margin: '15px 25px 10px 25px' }} />
              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                Soja
              </Typography>
            </Box>
            <Box>
              <img src={blueMaizIcon} alt="Maíz" style={{ width: '50px', margin: '15px 25px 10px 25px' }} />
              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                Maíz
              </Typography>
            </Box>
            <Box>
              <img src={blueTrigoIcon} alt="Trigo" style={{ width: '50px', margin: '15px 25px 10px 25px' }} />
              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                Trigo
              </Typography>
            </Box>
          </Stack>
        </Stack>
        <Stack direction="row" spacing={2} justifyContent={'center'} marginTop={4}>
          <Button
            sx={{ border: 'none', color: 'black', textTransform: 'none' }}
            onClick={() => {
              trigger({
                query: userID!,
                body: { was_rus_popup_shown: true },
              });
              setOpen(true);
              setIshowOneModal(true);
            }}
          >
            Quizás más tarde
          </Button>
          <Button
            variant="contained"
            sx={{
              ...configButtonStylesContained,
              padding: '0px 30px',
              backgroundColor: 'info.dark',
              '&:hover': {
                backgroundColor: 'info.dark',
              },
            }}
            onClick={() => {
              trigger({
                query: userID!,
                body: { was_rus_popup_shown: true },
              });
              setOpen(true);
              setIshowOneModal(true);
              navigate(PATH.SILOBAG);
            }}
          >
            Ir a Cotizar
          </Button>
        </Stack>
      </ModalIOF.Body>
    </ModalIOF>
  );
}
